var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiAssistantInActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.9375 1.25C16.7497 1.25 17.5287 1.57266 18.103 2.14699C18.6773 2.72132 19 3.50027 19 4.3125C19 5.12473 18.6773 5.90368 18.103 6.47801C17.5287 7.05234 16.7497 7.375 15.9375 7.375H12.875V4.3125C12.875 3.50027 13.1977 2.72132 13.772 2.14699C14.3463 1.57266 15.1253 1.25 15.9375 1.25Z",
    fill: "#A9B9C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.625 7.375H4.5625C3.75027 7.375 2.97132 7.05234 2.39699 6.47801C1.82266 5.90368 1.5 5.12473 1.5 4.3125C1.5 3.50027 1.82266 2.72132 2.39699 2.14699C2.97132 1.57266 3.75027 1.25 4.5625 1.25C5.37473 1.25 6.15368 1.57266 6.72801 2.14699C7.30234 2.72132 7.625 3.50027 7.625 4.3125V7.375Z",
    fill: "#A9B9C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.875 12.625H15.9375C16.7497 12.625 17.5287 12.9477 18.103 13.522C18.6773 14.0963 19 14.8753 19 15.6875C19 16.4997 18.6773 17.2787 18.103 17.853C17.5287 18.4273 16.7497 18.75 15.9375 18.75C15.1253 18.75 14.3463 18.4273 13.772 17.853C13.1977 17.2787 12.875 16.4997 12.875 15.6875V12.625Z",
    fill: "#A9B9C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M4.5625 18.75C3.75027 18.75 2.97132 18.4273 2.39699 17.853C1.82266 17.2787 1.5 16.4997 1.5 15.6875C1.5 14.8753 1.82266 14.0963 2.39699 13.522C2.97132 12.9477 3.75027 12.625 4.5625 12.625H7.625L7.625 15.6875C7.625 16.4997 7.30234 17.2787 6.72801 17.853C6.15368 18.4273 5.37473 18.75 4.5625 18.75Z",
    fill: "#A9B9C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5625 18.75C3.75027 18.75 2.97132 18.4273 2.39699 17.853C1.82266 17.2787 1.5 16.4997 1.5 15.6875C1.5 14.8753 1.82266 14.0963 2.39699 13.522C2.97132 12.9477 3.75027 12.625 4.5625 12.625H7.625L7.625 15.6875C7.625 16.4997 7.30234 17.2787 6.72801 17.853C6.15368 18.4273 5.37473 18.75 4.5625 18.75Z",
    stroke: "#A9B9C6",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 1.25C16.7497 1.25 17.5287 1.57266 18.103 2.14699C18.6773 2.72132 19 3.50027 19 4.3125C19 5.12473 18.6773 5.90368 18.103 6.47801C17.5287 7.05234 16.7497 7.375 15.9375 7.375H12.875V4.3125C12.875 3.50027 13.1977 2.72132 13.772 2.14699C14.3463 1.57266 15.1253 1.25 15.9375 1.25Z",
    stroke: "#A9B9C6",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 7.375H4.5625C3.75027 7.375 2.97132 7.05234 2.39699 6.47801C1.82266 5.90368 1.5 5.12473 1.5 4.3125C1.5 3.50027 1.82266 2.72132 2.39699 2.14699C2.97132 1.57266 3.75027 1.25 4.5625 1.25C5.37473 1.25 6.15368 1.57266 6.72801 2.14699C7.30234 2.72132 7.625 3.50027 7.625 4.3125V7.375Z",
    stroke: "#A9B9C6",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 12.625H15.9375C16.7497 12.625 17.5287 12.9477 18.103 13.522C18.6773 14.0963 19 14.8753 19 15.6875C19 16.4997 18.6773 17.2787 18.103 17.853C17.5287 18.4273 16.7497 18.75 15.9375 18.75C15.1253 18.75 14.3463 18.4273 13.772 17.853C13.1977 17.2787 12.875 16.4997 12.875 15.6875V12.625Z",
    stroke: "#A9B9C6",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 7.375H7.625V12.625H12.875V7.375Z",
    stroke: "#A9B9C6",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistantInActive);
export default __webpack_public_path__ + "static/media/AiAssistantInActive.4b4568b22a33b7dfdd3a464dfbbac705.svg";
export { ForwardRef as ReactComponent };